import { isNullable } from '@ipfabric/utils';
import {
  MIN_WINDOW_HEIGHT,
  MIN_WINDOW_WIDTH,
} from 'components/DeviceView/deviceViewConstants';
import type { DeviceViewEntityId } from 'components/DeviceView/deviceViewTypes';
import { getContainerDimensions } from 'components/DeviceView/helpers/getContainerDimensions';
import { getWindowGreatestZIndex } from 'components/DeviceView/helpers/getWindowGreatestZIndex';
import { pipe } from 'fp-ts/lib/function';
import type { DeviceViewCommandFactory } from '../DeviceViewModel';

interface DetachDeviceViewEntityCommand {
  deviceViewEntityId: DeviceViewEntityId;
}

export const detachDeviceViewEntity: DeviceViewCommandFactory<
  DetachDeviceViewEntityCommand
> = (cmdContext) => (command) => {
  const currentState = cmdContext.getState();

  if (isNullable(cmdContext.getState().deviceViewContainer)) {
    return;
  }

  cmdContext.updateState((draft) => {
    if (
      currentState.deviceViewWindows.some(
        (win) => win.id === command.deviceViewEntityId,
      )
    ) {
      return;
    }
    const zIndex: number = getWindowGreatestZIndex(
      currentState.deviceViewWindows,
    );
    const containerDimensions = getContainerDimensions(
      cmdContext.getState().deviceViewContainer,
    );
    const width = pipe(
      containerDimensions.width / 2,
      (w: number) => (w < MIN_WINDOW_WIDTH ? MIN_WINDOW_WIDTH : w),
      (w: number) => Math.round(w),
    );
    const height = pipe(
      containerDimensions.height / 2,
      (h: number) => (h < MIN_WINDOW_HEIGHT ? MIN_WINDOW_HEIGHT : h),
      (h: number) => Math.round(h),
    );
    const x = Math.round((containerDimensions.width - width) / 2);
    const y = Math.round((containerDimensions.height - height) / 2);
    draft.deviceViewWindows.push({
      beforeMaximizeHeight: 0,
      beforeMaximizeWidth: 0,
      beforeMaximizeX: 0,
      beforeMaximizeY: 0,
      height,
      id: command.deviceViewEntityId,
      maximize: false,
      width,
      x,
      y,
      zIndex: zIndex + 1,
    });
    if (
      currentState.deviceViewEntities.length === draft.deviceViewWindows.length
    ) {
      draft.deviceViewOpen = false;
    }
    draft.activeDeviceViewEntityId = null;
  });
};
